<nav class="tab-bar" role="tablist" [attr.aria-label]="ariaLabel()">
  @for (tab of tabs(); track tab.id) {
    <button
      type="button"
      class="tab-bar__tab"
      role="tab"
      [class.tab-bar__tab--active]="isActive(tab)"
      [attr.aria-selected]="isActive(tab)"
      [attr.aria-current]="isActive(tab) ? 'page' : null"
      (click)="handleSelect(tab)">
      <span class="tab-bar__indicator" aria-hidden="true"></span>
      <span class="tab-bar__icon-wrap">
        <i class="bx {{ tab.icon }} tab-bar__icon" aria-hidden="true"></i>
        @if (tab.badge) {
          <span class="tab-bar__badge" [attr.aria-label]="tab.badge + ' new'">{{ tab.badge }}</span>
        }
      </span>
      <span class="tab-bar__label">{{ tab.label }}</span>
    </button>
  }
</nav>
